<!--
- 文章列表组件
- anthor: wang.y
- greatTime: 2019-12-09
-->
<template>
    <li>
        <div class="article-img" @click="goDetail(dataLi)">
            <img :src="dataLi.logo_path | logo_show" />
        </div>
        <div class="article-info">
            <div class="article-title" @click="goDetail(dataLi)" v-html="filter.keyWordHighLight(dataLi.title, keyword)"></div>
            <div class="article-summary" @click="goDetail(dataLi)" v-html="filter.keyWordHighLight(dataLi.summary, keyword)"></div>
            <div class="article-dec">
                <img :src="dataLi.author_logo_path | logo_show('', $store.state.static_img_url+'pic/default_header.png')" class="header-img"/>
                <span class="author">{{dataLi.author_name}}</span>
                <span class="time">{{dataLi.publish_time | time_standard}}</span>
            </div>
            <div class="article-btm">
                <div class="tags" v-if="dataLi.tag_ids">
                    <i class="iconfont">&#xe660;</i>
                    <span v-for="item,index in dataLi.tag_ids.split(',')" @click="handleClickTags(item)">{{item | dealName(meta.media_tag)}}</span>
                </div>
                <div class="collect_share">
                    <i class="iconfont s active" title="取消收藏" v-if="dataLi.is_collect > 0" @click="cancelCollect('4', dataLi.id, delCollectCb)">&#xe66f;</i>
                    <i class="iconfont s" title="收藏" v-else  @click="addCollect('4', dataLi.id, addCollectCb)">&#xe66f;</i>
                    <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(dataLi)" @on-popper-hide="haddleShareHide">
                        <i class="iconfont w">&#xe641;</i>
                        <div slot="content" class="share_cnt clear">
                          <div class="share_img"></div>
                          <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                        </div>
                    </Poptip>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import filter from 'js/filter'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [ collect_mixin ],
  props: ['dataLi', 'keyword', 'meta'],
  data() {
    return {
      filter: filter
    }
  },
  methods: {
    addCollectCb() {
      this.dataLi.is_collect = 1
    },
    delCollectCb() {
      this.dataLi.is_collect = 0
    },
    haddleShare(item) {
      let share_link = this.$store.state.index2_path + '/' + item.id
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    goDetail(item) {
      const href = this.$store.state.index2_path + '/' + item.id
      window.open(href, '_blank')
    },
    handleClickTags(item) {
      window.open(this.$store.state.index2_path + '/Article/labelList/keyword/' + item)
    }
  }
}

</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
li
  display: flex
  &+li
    margin-top: 30px
  .article
    &-img
      position: relative
      flex: 0 0 242px
      height: 152px
      overflow: hidden
      cursor: pointer
      img
        width: 100%
        height: 100%
        transition_02s()
      &:hover
        img
          transform: scale(1.05, 1.05)
    &-info
      margin-left: 20px
      position: relative
      flex: auto
    &-title
    &-summary
      font-size:18px
      font-weight:600
      commonColor(#e9e9eb, #333333)
      line-height:26px
      max-height: 52px
      display: -webkit-box
      overflow: hidden
      text-overflow: ellipsis
      word-break: break-all
      -webkit-box-orient: vertical
      -webkit-line-clamp: 2
      cursor: pointer
      &:hover
        color: rgba(250, 122, 80, 1) !important
    &-summary
      font-size:14px
      font-weight:400
      commonColor(#bcbdc1, #666666)
      line-height:22px
      max-height: 22px
      margin-top: 7px
      -webkit-line-clamp: 1
    &-dec
      margin-top: 10px
      .header-img
        width: 24px
        height: 24px
        border-radius: 12px
        display: inline-block
        vertical-align: top
      .author
      .time
        display: inline-block
        vertical-align: top
        line-height: 24px
        font-size: 12px
        commonColor(#bcbdc1, #666666)
        margin-left: 10px
    &-btm
      position: absolute
      bottom: 0
      display: flex
      width: 100%
      justify-content: flex-end
      .tags
        flex: auto
        color: rgba(250, 122, 80, 1)
        line-height: 18px
        ellipsisClamp2()
        margin-right 10px
        i
          font-size: 13px
          display: inline-block
          vertical-align: top
          margin-right: 6px
        span
          cursor: pointer
          &:hover
            color: #FC9C7C
        span+span
          margin-left: 16px
      .collect_share
        flex: 0 0 44px
  >>> .high-light
    color: rgba(250, 122, 80, 1) !important
    font-style: normal
</style>
